import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSpring, animated } from "react-spring";
import CustomConfirmBox from "../../DashBoard/customConfirmBox";
import renderSlotDetails from "./banking";
import Styles from "../../../Styles/Banking/bankingList.module.css";
import bankingService from "../../../components/Services/banking.service";
import { disableButton, enableButton } from "../../../store/ButtonFlag/actions";
import { toastProperties } from "../../../commons/Toast/Toaster";

const BankingRequestModal = ({
 isOpen,
 closeAddsBidsModal,
 bidItem,
 selectedCardData,
 getMatchingBankingListings,
}) => {
 const dispatch = useDispatch();
 const configKey = useSelector((state) => state?.sessionState?.connectionName);
 const isButtonEnabled = useSelector(
  (state) => state?.buttonReducer?.isButtonEnabled
 );

 const [showDetails, setShowDetails] = useState({});

 const handleConnectionRequest = () => {
  disableButton()(dispatch)
  const requestBody = {
    "bankingListingId": selectedCardData?.id,
    "againstBankingListingId": isOpen?.id,
  }
    bankingService.placeBankingConnectionRequest(requestBody).then((response) => {
      if (response?.data?.code === 200) {
        toast.success(response?.data?.message, toastProperties)
        getMatchingBankingListings(selectedCardData?.id)
        closeAddsBidsModal()
        enableButton()(dispatch);
      } else if (response?.data?.code !== 200) {
        enableButton()(dispatch);
      }
    }).catch(error => {
      console.error('API call error', error);
      enableButton()(dispatch);
    }) ;
 };


 const styles = useSpring({
  from: { transform: "translateX(100%)" },
  to: { transform: "translateX(-70%)" },
  config: { duration: "15000" },
  loop: true,
 });

function handleShowDetails(type, index, e) {
  e.stopPropagation();
  setShowDetails((prevState) => ({
   ...prevState,
   [type]: {
    ...prevState[type],
    [index]: !prevState[type]?.[index],
   },
  }));
 }
 return (
  <>
   <Modal
    show={Boolean(isOpen)}
    className="modal"
    size="xl"
    onHide={closeAddsBidsModal}
    centered
   >
    <Modal.Header closeButton>
     <Modal.Title>
      <span style={{textTransform:"capitalize"}}>
        {configKey} Request
      </span>
      </Modal.Title>
    </Modal.Header>
     <Modal.Body className="modal-scrollY ">
      <div className=" container my-2">
       <Formik >
        {({ values, setFieldValue, setFieldTouched, setValues }) => {
         return (
          <Form>
           <div className="capacity-slots-col mb-4">
            <div className="capacity-slots-col-card mx-auto">
             <div className=" pull-right clearfix"></div>
             <h6 className=" text-center">My Listing</h6>
             <h6 className=" text-center">{selectedCardData?.name}</h6>
             <div className="dashboard-slot dashboard-slot-date-time my-3 justify-content-center">
                <div>
                 <div>Injection</div>
                </div>
                <div>:</div>
                {renderSlotDetails(
                 selectedCardData?.bankingSlotInjects,
                 "injection",
                 selectedCardData?.id,showDetails
                )}
                {selectedCardData?.bankingSlotInjects?.length > 1 && (
                 <a
                  className={Styles.linkTextBanking}
                  onClick={(e) =>
                   handleShowDetails("injection", selectedCardData?.id, e)
                  }
                 >
                  {showDetails["injection"]?.[selectedCardData?.id] ? "less" : "more"}
                 </a>
                )}
               </div>
               <div className="dashboard-slot dashboard-slot-date-time my-3 justify-content-center">
                <div>
                 <div>Drawal</div>
                </div>
                <div>:</div>
                {renderSlotDetails(
                 selectedCardData?.bankingSlotDrawls,
                 "drawal",
                 selectedCardData?.id,showDetails
                )}
                {selectedCardData?.bankingSlotDrawls?.length > 1 && (
                 <a
                  className={Styles.linkTextBanking}
                  onClick={(e) => {
                   handleShowDetails("drawal", selectedCardData?.id, e);
                  }}
                 >
                  {showDetails["drawal"]?.[selectedCardData?.id] ? "less" : "more"}
                 </a>
                )}
               </div>
             <div className="testfortest">
              <div className="energy-cost-unit-box w-100">
               <div
                className="energy-cost-unit-box-content"
                style={{ display: "flex", alignItems: "center" }}
               >
                Quantity (MW) :
                <Field
                 type="text"
                 name="sellEnergy"
                 className="energy-cost-unit-field-content"
                 readOnly
                 placeholder={selectedCardData?.requiredQty}
                />
               </div>
               <div
                className="energy-cost-unit-box-content"
                style={{ display: "flex", alignItems: "center" }}
               >
                BF (%) :
                <Field
                 type="text"
                 name="sellAmount"
                 className="energy-cost-unit-field-content"
                 readOnly
                 placeholder={selectedCardData?.bankingFactor}
                />
               </div>
               <div
                className="energy-cost-unit-box-content"
                style={{ display: "flex", alignItems: "center" }}
               >
                TODF (%) :
                <Field
                 type="text"
                 name="sellAmount"
                 className="energy-cost-unit-field-content"
                 readOnly
                 placeholder={selectedCardData?.timeOfDrawlFactor}
                />
               </div>
              </div>
              {/* <div className="c-icons-group-child-cap">
               <div
                onClick={(e) => {
                 // openChildCapacityModal()
                }}
               >
                <OverlayTrigger
                 placement="top"
                 overlay={<Tooltip>Edit Capacity</Tooltip>}
                >
                 <div>
                  <i className="fa fa-pencil c-icons"></i>
                 </div>
                </OverlayTrigger>
               </div>
              </div> */}
             </div>
             <div className="small mt-3 text-center">{selectedCardData?.expiryAt}</div>
            </div>
            <div className="capacity-slots-col-card mx-auto">
             <div className=" pull-right clearfix"></div>
             <h6 className=" text-center">Discom Listing</h6>
             <h6 className=" text-center">{isOpen?.name}</h6>
             <div className="dashboard-slot dashboard-slot-date-time my-3 justify-content-center">
                <div>
                 <div>Injection</div>
                </div>
                <div>:</div>
                {renderSlotDetails(
                 isOpen?.bankingSlotInjects,
                 "discomInjection",
                 isOpen?.id,showDetails
                )}
                {isOpen?.bankingSlotInjects?.length > 1 && (
                 <a
                  className={Styles.linkTextBanking}
                  onClick={(e) =>
                   handleShowDetails("discomInjection", isOpen?.id, e)
                  }
                 >
                  {showDetails["discomInjection"]?.[isOpen?.id] ? "less" : "more"}
                 </a>
                )}
               </div>
               <div className="dashboard-slot dashboard-slot-date-time my-3 justify-content-center">
                <div>
                 <div>Drawal</div>
                </div>
                <div>:</div>
                {renderSlotDetails(
                 isOpen?.bankingSlotDrawls,
                 "discomDrawal",
                 isOpen?.id,showDetails
                )}
                {isOpen?.bankingSlotDrawls?.length > 1 && (
                 <a
                  className={Styles.linkTextBanking}
                  onClick={(e) => {
                   handleShowDetails("discomDrawal", isOpen?.id, e);
                  }}
                 >
                  {showDetails["discomDrawal"]?.[isOpen?.id] ? "less" : "more"}
                 </a>
                )}
               </div>
             <div className="testfortest">
              <div className="energy-cost-unit-box w-100">
               <div
                className="energy-cost-unit-box-content"
                style={{ display: "flex", alignItems: "center" }}
               >
                Quantity (MW) :
                <Field
                 type="text"
                 name="sellEnergy"
                 className="energy-cost-unit-field-content"
                 readOnly
                 placeholder={isOpen?.requiredQty}
                />
               </div>
               <div
                className="energy-cost-unit-box-content"
                style={{ display: "flex", alignItems: "center" }}
               >
                BF (%) :
                <Field
                 type="text"
                 name="sellAmount"
                 className="energy-cost-unit-field-content"
                 readOnly
                 placeholder={isOpen?.bankingFactor}
                />
               </div>
               <div
                className="energy-cost-unit-box-content"
                style={{ display: "flex", alignItems: "center" }}
               >
                TODF (%) :
                <Field
                 type="text"
                 name="sellAmount"
                 className="energy-cost-unit-field-content"
                 readOnly
                 placeholder={isOpen?.timeOfDrawlFactor}
                />
               </div>
              </div>
              {/* <div className="c-icons-group-child-cap">
              <div
                onClick={(e) => {
                 // openCapacityHistoryModal()
                }}
               >
                <OverlayTrigger
                 placement="top"
                 overlay={<Tooltip>View History</Tooltip>}
                >
                 <div>
                  <i className="bi bi-clock-history c-icons"></i>
                 </div>
                </OverlayTrigger>
               </div>
              </div> */}
             </div>
             <div className="small mt-3 text-center">{isOpen?.expiryAt}</div>
            </div>
           </div>
           <div
            className="company-profile-btn-group mt-4 justify-content-center"
           >
            <button
             type="button"
             className="btn btn-login"
             disabled={isButtonEnabled}
             onClick={handleConnectionRequest}
            >
             Connect
            </button>
           </div>
          </Form>
         );
        }}
       </Formik>
      </div>
     </Modal.Body>
   </Modal>
  </>
 );
};

export default BankingRequestModal;
